import React, { useState } from "react";
import API from "../../ApiService/ApiService";
import Context from "./index";
import Widget from "../../Helpers/Widget";

const PlansProvider = (props) => {
  const api = new API();
  const [tableFilter, setTableFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [tableFilterSub, setTableFilterSub] = useState({
    name: "",
    plan_id: null,
    page: 1,
    limit: 20,
  });
  const [planLoader, setPlanLoader] = useState({
    list: false,
    add: false,
    edit: false,
    update: false,
    delete: false,
    single: false,
    category: false,
  });
  const [planCategoryList, setPlanCategoryList] = useState([]);
  const [planSubCategoryList, setPlanSubCategoryList] = useState([]);
  const [planError, setPlanError] = useState(null);
  const [planList, setPlanList] = useState([]);
  const [planListSub, setPlanListSub] = useState([]);
  const [planSubLoader, setPlanSubLoader] = useState(false);
  const [planSingle, setPlanSingle] = useState({});
  const [singleId, setSingleId] = useState(null);
  const [openViewPopup, setOpenViewPopup] = useState(false);
  const [onActivePlan, setOnActivePlan] = useState(false);
  const [planSubCategoryLoader, setPlanSubCategoryLoader] = useState(false);
  const [plandropdown, setPlansDropdown] = useState([]);

  const [planAddForm, setPlanAddForm] = useState({
    plan_name: "",
    category: [],
    product: [],
    plan_type: "",
    sub_category: [],
    duration: [
      {
        amount: null,
        special_offer: null,
        recommended: false,
        year: null,
        month: null,
        day: null,
        ios_plan_id: null,
        ios_plan_amount: null,
        ios_plan_show: false,
      },
    ],
    description: "",
  });
  const [planEditForm, setPlanEditForm] = useState({
    plan_name: "",
    category: [],
    sub_category: [],
    product: [],
    plan_type: "",
    duration: [
      {
        amount: null,
        special_offer: null,
        recommended: false,
        year: null,
        month: null,
        day: null,
        ios_plan_id: null,
                ios_plan_amount: null,
                ios_plan_show: false,
      },
    ],
    description: "",
  });
  const [planDeleteLoader, setPlanDeleteLoader] = useState(false);
  const [salesTableFilter, setSalesTableFilter] = useState({
    s: "",
    plan_id: null,
    page: 1,
    limit: 20,
    plan_id: null,
    payment_status: null,
    sort_by: null,
    range:null,
  });
  const [salseTableLoading, setSalseTableLoading] = useState(false);
  const [salseTableLoadingExport, setSalseTableLoadingExport] = useState(false);
  const [salesList, setSalesList] = useState([]);
  const fetchSalesList = async () => {
    setSalseTableLoading(true);
    localStorage.getItem("rxdx_admin_login") &&
      api.getAll(
        "plans/plan/track_list",
        { ...salesTableFilter },
        (err, res) => {
          if (res) {
            setSalesList(res?.data?.data);
          } else {
            setSalesList([]);
          }
          setSalseTableLoading(false);
        }
      );
  };
  const fetchSalesListExport = async () => {
    setSalseTableLoadingExport(true);
    localStorage.getItem("rxdx_admin_login") &&
      api.getAll(
        "plans/plan/track_export",
        { ...salesTableFilter },
        (err, res) => {
          if (res) {
            Widget.showMessage("success", "The sales list has been successfully exported and sent to your email");
          } else {
            Widget.showMessage("error", err?.response?.data?.message);
          }
          setSalseTableLoadingExport(false);
        }
      );
  };
  // plan list
  const fetPlansMasterDropdown = async () => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("coupons/plandropdown", {}, (err, res) => {
        if (res?.data?.status === 200) {
          setPlansDropdown(res?.data?.data);
          // console.log("plansDropdown", res?.data?.data);
        } else {
          setPlansDropdown([]);
        }
      }));
  };

  const deletePlan = async (id) => {
    setPlanDeleteLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.remove("plans/deleteplans", id, (err, res) => {
        if (res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
          fetchPlanMaster();
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setPlanDeleteLoader(false);
      }));
  };
  const fetCategoryPlan = async () => {
    setPlanLoader({
      ...planLoader,
      category: true,
    });
    localStorage.getItem("rxdx_admin_login") &&
      api.getAll("plans/getcategorylist", {}, (err, res) => {
        if (res) {
          setPlanCategoryList(res?.data?.data);
        } else {
          setPlanCategoryList([]);
        }
      });
    setPlanLoader({
      ...planLoader,
      category: false,
    });
  };
  const fetSubCategoryPlan = async (id) => {
    setPlanSubCategoryLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      api.getAll(
        "plans/getsubcategorylist",
        { category_id: id },
        (err, res) => {
          if (res) {
            setPlanSubCategoryList(res?.data?.data);
          } else {
            setPlanSubCategoryList([]);
          }
        }
      );
    setPlanSubCategoryLoader(false);
  };

  const fetchPlanMaster = async () => {
    setPlanLoader((prev) => ({
      ...prev,
      list: true,
    }));
    localStorage.getItem("rxdx_admin_login") &&
      api.getAll("plans", { ...tableFilter }, (err, res) => {
        if (res) {
          setPlanList(res?.data?.data);
        } else {
          setPlanList([]);
        }
        setPlanLoader((prev) => ({
          ...prev,
          list: false,
        }));
      });
  };

  const fetchPlanMasterSub = async (pid) => {
    setPlanSubLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      api.getAll(
        "plans/plan/list",
        { ...tableFilterSub, plan_id: pid },
        (err, res) => {
          if (res) {
            setPlanListSub(res?.data?.data);
          } else {
            setPlanListSub([]);
          }
          setPlanSubLoader(false);
        }
      );
  };

  const addPlans = async (data) => {
    setPlanLoader({
      ...planLoader,
      add: true,
    });
    const form_data = new FormData();
    form_data.append("plan_name", data?.plan_name || "");
    if (data?.category) {
      [data.category].forEach((item) => form_data.append("category[]", item));
    }
    if (data?.sub_category) {
      const subCategories = Array.isArray(data?.sub_category)
        ? data?.sub_category
        : [data?.sub_category];
      subCategories.forEach((item, index) =>
        form_data.append(`sub_category[${index}]`, item)
      );
    }
    if (data?.product) {
      data.product.forEach((item) => form_data.append("product[]", item));
    }
    form_data.append("plan_type", data?.plan_type || "");
    form_data.append("description", data?.description || "");
    if (data?.duration) {
      data?.duration?.forEach((item, index) => {
        form_data.append(`duration[${index}][amount]`, item?.amount || 0);
        form_data.append(
          `duration[${index}][special_offer]`,
          item?.special_offer || 0
        );
        form_data.append(
          `duration[${index}][recommended]`,
          item?.recommended || false
        );
        form_data.append(`duration[${index}][year]`, item?.year || 0);
        form_data.append(`duration[${index}][month]`, item?.month || 0);
        form_data.append(`duration[${index}][day]`, item?.day || 0);
        form_data.append(
          `duration[${index}][ios_plan_id]`,
          item?.ios_plan_id || ""
        );
        form_data.append(
          `duration[${index}][ios_plan_amount]`,
          item?.ios_plan_amount || 0
        );
        form_data.append(
          `duration[${index}][ios_plan_show]`,
          item?.ios_plan_show || false
        );
      });
    }

    const res =
      localStorage.getItem("rxdx_admin_login") &&
      api.create("plans/addplans", form_data, (err, res) => {
        if (res) {
          Widget.showMessage("success", res?.data?.message);
          setPlanAddForm({
            ...planAddForm,
            plan_name: "",
            category: [],
            product: [],
            plan_type: "",
            duration: [
              {
                amount: null,
                special_offer: null,
                recommended: false,
                year: null,
                month: null,
                day: null,
                ios_plan_id: null,
                ios_plan_amount: null,
                ios_plan_show: false,
              },
            ],
            description: "",
          });
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setPlanLoader({
          ...planLoader,
          add: false,
        });
      });

    return res;
  };

  const getSinglePLan = async (id) => {
    setPlanLoader({
      ...planLoader,
      single: true,
    });
    const res =
      localStorage.getItem("rxdx_admin_login") &&
      api.getSingle("plans", id, (err, res) => {
        if (res) {
          setPlanSingle(res?.data?.data);
          setPlanEditForm({
            ...res?.data?.data,
            category: [...res?.data?.data?.category.map((item) => item?._id)],
          });
          setSingleId(res?.data?.data?._id);
          setOnActivePlan(res?.data?.data?.status === 1 ? true : false);
          fetSubCategoryPlan(res?.data?.data?.category[0]?._id);
        } else {
          setPlanSingle({});
          setPlanEditForm({
            plan_name: "",
            category: [],
            sub_category: [],
            product: [],
            plan_type: "",
            duration: [
              {
                amount: null,
                special_offer: null,
                recommended: false,
                year: null,
                month: null,
                day: null,
                ios_plan_id: null,
                ios_plan_amount: null,
                ios_plan_show: false,
              },
            ],
            description: "",
          });
          setSingleId(null);
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setPlanLoader({
          ...planLoader,
          single: false,
        });
      });

    return res;
  };

  const updatePlans = async (data, id) => {
    setPlanLoader({
      ...planLoader,
      update: true,
    });
    const form_data = new FormData();
    form_data.append("plan_name", data?.plan_name || "");
    if (data?.category) {
      [data.category].forEach((item) => form_data.append("category[]", item));
    }
    // if (data?.sub_category) {
    //   [data.sub_category].forEach(item => form_data.append("sub_category[]", item));
    // }
    if (data?.product) {
      data.product.forEach((item) => form_data.append("product[]", item));
    }
    if (data?.sub_category) {
      const subCategories = Array.isArray(data?.sub_category)
        ? data?.sub_category
        : [data?.sub_category];
      subCategories.forEach((item, index) =>
        form_data.append(`sub_category[${index}]`, item)
      );
    }
    form_data.append("plan_type", data?.plan_type || "");

    form_data.append("description", data?.description || "");
    if (data?.duration) {
      data?.duration?.forEach((item, index) => {
        form_data.append(`duration[${index}][amount]`, item?.amount || 0);
        form_data.append(
          `duration[${index}][special_offer]`,
          item?.special_offer || 0
        );
        form_data.append(
          `duration[${index}][recommended]`,
          item?.recommended || false
        );
        form_data.append(`duration[${index}][year]`, item?.year || 0);
        form_data.append(`duration[${index}][month]`, item?.month || 0);
        form_data.append(`duration[${index}][day]`, item?.day || 0);
        if (item?._id) {
          form_data.append(`duration[${index}][_id]`, item?._id);
        }
        form_data.append(
          `duration[${index}][ios_plan_id]`,
          item?.ios_plan_id || ""
        );
        form_data.append(
          `duration[${index}][ios_plan_amount]`,
          item?.ios_plan_amount || 0
        );
        form_data.append(
          `duration[${index}][ios_plan_show]`,
          item?.ios_plan_show || false
        );
      });
    }

    const res =
      localStorage.getItem("rxdx_admin_login") &&
      api.update("plans", id, form_data, (err, res) => {
        if (res) {
          Widget.showMessage("success", res?.data?.message);
          setPlanEditForm({
            ...planEditForm,
            plan_name: "",
            category: [],
            sub_category: [],
            product: [],
            plan_type: "",
            duration: [
              {
                amount: null,
                special_offer: null,
                recommended: false,
                year: null,
                month: null,
                day: null,
                ios_plan_id: null,
                ios_plan_amount: null,
                ios_plan_show: false,
              },
            ],
            description: "",
          });
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setPlanLoader({
          ...planLoader,
          update: false,
        });
      });

    return res;
  };

  const statusUpdate = async (status = null, id = null) => {
    if (!id) {
      Widget.showMessage("error", "ID is required");
      return;
    }
    if (status === null || status === "" || status === undefined) {
      Widget.showMessage("error", "Status is required");
      return;
    }
    const res =
      localStorage.getItem("rxdx_admin_login") &&
      api.update("plans/status", id, { status: status }, (err, res) => {
        if (res) {
          setPlanSingle((prev) => ({
            ...prev,
            status: res?.data?.data?.status,
          }));
          Widget.showMessage("success", res?.data?.message);
          fetchPlanMaster();
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
      });
    return res;
  };

  return (
    <Context.Provider
      value={{
        ...props,
        planLoader,
        setPlanLoader,
        planAddForm,
        setPlanAddForm,
        fetCategoryPlan,
        planCategoryList,
        setPlanCategoryList,
        planError,
        setPlanError,
        addPlans,
        planList,
        setPlanList,
        fetchPlanMaster,
        tableFilter,
        setTableFilter,
        planEditForm,
        setPlanEditForm,
        planSingle,
        setPlanSingle,
        singleId,
        setSingleId,
        getSinglePLan,
        updatePlans,
        openViewPopup,
        setOpenViewPopup,
        statusUpdate,
        onActivePlan,
        setOnActivePlan,
        planDeleteLoader,
        setPlanDeleteLoader,
        deletePlan,
        fetSubCategoryPlan,
        planSubCategoryList,
        setPlanSubCategoryList,
        planSubCategoryLoader,
        setPlanSubCategoryLoader,

        tableFilterSub,
        setTableFilterSub,
        fetchPlanMasterSub,
        planSubLoader,
        setPlanSubLoader,
        planListSub,
        setPlanListSub,
        //
        salesTableFilter,
        setSalesTableFilter,
        salseTableLoading,
        setSalseTableLoading,
        salesList,
        setSalesList,
        fetchSalesList,
        //
        plandropdown,
        setPlansDropdown,
        fetPlansMasterDropdown,
        salseTableLoadingExport, setSalseTableLoadingExport,
        fetchSalesListExport
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default PlansProvider;
